app.factory('article', ['$http','Config',function($http,Config) {

	var factoryFns =  {
	  getRelatedProducts: function(articleID, width, height){
		  query_string = '?brand='+Config.brand_key+'&article-id='+articleID+'&width='+width+'&height='+height;
	  	return $http({
		  method: 'GET',
		  url: Config.api_url+'article/related-products'+query_string,
		  headers:{
		  	'authorization':Config.api_key
		  }
		})
	  }
	};

	return factoryFns;

}]);